export class FieldStyle {
    fontSize: number;
    fontWeight: string;
    fontStyle: string;
    textOrientation: string;
    textAlign: string;
}
